// Translations for CollectPay landing page
export const translations = {
  es: {
    nav: {
      benefits: "Beneficios",
      features: "Funcionalidades",
      process: "Proceso",
      pricing: "Planes",
      testimonials: "Testimonios",
      faq: "FAQ",
      requestDemo: "Solicitar demo",
      login: "Empezar",
      register: "Registrarte"
    },
    hero: {
      badge: "Solución fintech para PYMEs",
      title: "Recupera tu flujo de caja y optimiza tu cobranza",
      subtitle: "Plataforma tecnológica de cobranza automatizada con IA para PYMEs. Aumenta tu recuperación de cartera hasta un 45% y reduce costos operativos hasta un 80%.",
      ctaPrimary: "Solicitar demo",
      ctaSecondary: "Ver planes",
      metric1: "Recuperación",
      metric2: "Costos",
      metric3: "Empresas",
      metric4: "Disponible",
      trust: "+100 empresas confían en nosotros"
    },
    benefits: {
      title: "Beneficios que",
      titleHighlight: "transforman",
      titleEnd: "tu negocio",
      subtitle: "Soluciones que generan resultados medibles desde el primer mes",
      items: [
        { title: "Aumenta tu recuperación", description: "Incrementa las tasas de recuperación de cartera entre 20% y 45% con automatización inteligente.", metric: "+45%", metricLabel: "Recuperación" },
        { title: "Mejora tu flujo de caja", description: "Mejora significativa en el flujo de caja desde el primer mes de implementación.", metric: "Mes 1", metricLabel: "Resultados" },
        { title: "Reduce costos", description: "Disminuye los costos operativos de cobranza hasta un 80% automatizando procesos manuales.", metric: "-80%", metricLabel: "Costos" },
        { title: "Escalabilidad", description: "Escala tus operaciones sin aumentar proporcionalmente tu estructura operacional.", metric: "24/7", metricLabel: "Disponible" }
      ]
    },
    features: {
      title: "Tecnología que",
      titleHighlight: "impulsa",
      titleEnd: "resultados",
      subtitle: "Funcionalidades diseñadas para maximizar tu eficiencia y recuperación",
      badge: "Funcionalidad",
      items: [
        {
          title: "Automatización completa",
          description: "Automatiza todo tu proceso de cobranza extrajudicial y judicial con tecnología de punta.",
          features: ["Cobranza extrajudicial automatizada", "Gestión de cobranza judicial", "Seguimiento automático de deudores", "Comunicación omnicanal automatizada"]
        },
        {
          title: "Inteligencia artificial",
          description: "Optimiza tus estrategias de cobranza con IA que aprende de tus datos y mejora continuamente.",
          features: ["Optimización con IA", "Lectura automatizada de facturas", "Predicción de comportamiento de pago", "Recomendaciones inteligentes"]
        },
        {
          title: "Visibilidad total",
          description: "Reportes en tiempo real y acceso 24/7 desde cualquier lugar con nuestra plataforma en la nube.",
          features: ["Reportes en tiempo real", "Plataforma cloud 24/7", "Dashboard personalizable", "Integración con sistemas existentes"]
        }
      ]
    },
    process: {
      title: "Proceso de",
      titleHighlight: "implementación",
      titleEnd: "simple",
      subtitle: "Te acompañamos en cada paso para garantizar tu éxito",
      steps: [
        { step: "01", title: "Validación del proyecto", description: "Analizamos tus necesidades específicas y diseñamos la propuesta de valor ideal para tu negocio." },
        { step: "02", title: "Desarrollo y personalización", description: "Configuramos la plataforma según tus requerimientos y la integramos con tus sistemas existentes." },
        { step: "03", title: "Capacitación", description: "Entrenamos a tu equipo para aprovechar al máximo todas las funcionalidades de la plataforma." },
        { step: "04", title: "Soporte continuo", description: "6 meses de garantía post-venta con asistencia especializada y continua para tu éxito." }
      ]
    },
    clients: {
      title: "Empresas que confían en",
      titleHighlight: "nosotros",
      subtitle: "Casos de éxito en diferentes sectores e industrias",
      footer: "Más de 100 empresas han transformado su gestión de cobranza con nosotros"
    },
    pricing: {
      title: "Planes diseñados para tu",
      titleHighlight: "crecimiento",
      subtitle: "Sin contratos de permanencia ni cuotas fijas. Adquieres paquetes de recarga según el volumen de tu operación.",
      popular: "Más popular",
      annual: "prepago",
      request: "Solicitar",
      successTitle: "Honorarios por éxito",
      successHighlight: "(solo cuando recuperas)",
      successFooter: "Comisiones escalonadas según la etapa de mora. Solo pagas honorarios cuando recuperas efectivamente.",
      stages: [
        { stage: "Prejurídica", days: "91-180 días", fee: "5%", description: "Mora media" },
        { stage: "Jurídica", days: "181-360 días", fee: "10%", description: "Mora avanzada" },
        { stage: "Castigada", days: "+360 días", fee: "15%", description: "Cartera castigada" }
      ]
    },
    testimonials: {
      title: "Lo que dicen nuestros",
      titleHighlight: "clientes",
      subtitle: "PYMEs que transformaron su gestión de cobranza y mejoraron su liquidez"
    },
    faq: {
      title: "Preguntas",
      titleHighlight: "frecuentes",
      subtitle: "Respuestas a las dudas más comunes sobre CollectPay",
      notFound: "¿No encontraste la respuesta que buscabas?",
      contactUs: "Contáctanos directamente →"
    },
    contact: {
      title: "¿Listo para",
      titleHighlight: "transformar",
      titleEnd: "tu cobranza?",
      subtitle: "Solicita tu demo personalizada y descubre cómo podemos ayudarte a reactivar tu liquidez",
      formName: "Nombre completo",
      formEmail: "Email",
      formPhone: "Teléfono",
      formCompany: "Empresa",
      formPlan: "Plan de interés",
      formPlanPlaceholder: "Selecciona un plan",
      formMessage: "Mensaje",
      formMessagePlaceholder: "Cuéntanos sobre tus necesidades de cobranza...",
      submit: "Solicitar demo",
      submitting: "Enviando...",
      success: "¡Solicitud enviada!",
      successDesc: "Nos pondremos en contacto contigo en las próximas 24 horas.",
      error: "Error al enviar",
      errorDesc: "Por favor intenta de nuevo o llámanos directamente.",
      legal: "Al enviar este formulario, aceptas nuestros",
      and: "y",
      info: "Información de contacto",
      phone: "Teléfono",
      email: "Email",
      office: "Oficina",
      whyTitle: "¿Por qué solicitar una demo?",
      why1: "Ver la plataforma en acción con tus datos",
      why2: "Asesoría personalizada sin compromiso",
      why3: "Cotización ajustada a tu volumen",
      why4: "Respuesta en menos de 24 horas",
      captchaLabel: "Verificación de seguridad",
      captchaError: "La respuesta es incorrecta. Por favor intenta de nuevo."
    },
    footer: {
      tagline: "Plataforma fintech líder en automatización de cobranza para PYMEs. Mejoramos tu flujo de caja con tecnología e inteligencia artificial.",
      product: "Producto",
      productItems: ["Beneficios", "Funcionalidades", "Planes y Precios", "Solicitar Demo"],
      company: "Empresa",
      companyItems: ["Sobre Nosotros", "Blog", "Casos de Éxito", "Carreras"],
      support: "Soporte",
      supportItems: ["Preguntas Frecuentes", "Centro de Ayuda", "Contacto", "Estado del Sistema"],
      legal: "Legal",
      legalItems: ["Términos y Condiciones", "Política de Privacidad", "Tratamiento de Datos", "Seguridad"],
      copyright: "© 2026 CollectPay. Todos los derechos reservados.",
      madeWith: "Hecho con ♥ para PYMEs"
    },
    whatsapp: {
      message: "¡Hola! Me interesa conocer más sobre CollectPay para mi empresa."
    },
    careers: {
      title: "Trabaja con nosotros",
      subtitle: "Únete al equipo que está transformando la cobranza en Colombia",
      formName: "Nombre completo",
      formEmail: "Email",
      formPosition: "Cargo de interés",
      formPositionPlaceholder: "Ej: Desarrollador, Analista, Comercial",
      formMessage: "Carta de presentación (opcional)",
      formMessagePlaceholder: "Cuéntanos brevemente por qué quieres trabajar con nosotros...",
      formCV: "Adjunta tu CV (PDF o Word, máx 5MB)",
      formCVHint: "Arrastra tu archivo aquí o haz click para seleccionar",
      submit: "Enviar aplicación",
      submitting: "Enviando...",
      success: "¡Aplicación enviada!",
      successDesc: "Gracias por tu interés. Revisaremos tu CV y te contactaremos pronto.",
      error: "Error al enviar",
      errorDesc: "Por favor intenta de nuevo o envía tu CV a hola@collectpay.co",
      close: "Cerrar"
    }
  },
  en: {
    nav: {
      benefits: "Benefits",
      features: "Features",
      process: "Process",
      pricing: "Pricing",
      testimonials: "Testimonials",
      faq: "FAQ",
      requestDemo: "Request demo",
      login: "Sign in",
      register: "Get started"
    },
    hero: {
      badge: "Fintech solution for SMBs",
      title: "Recover your cash flow and optimize your collections",
      subtitle: "AI-powered automated collections platform for SMBs. Increase your portfolio recovery by up to 45% and reduce operating costs by up to 80%.",
      ctaPrimary: "Request demo",
      ctaSecondary: "View plans",
      metric1: "Recovery",
      metric2: "Costs",
      metric3: "Companies",
      metric4: "Available",
      trust: "+100 companies trust us"
    },
    benefits: {
      title: "Benefits that",
      titleHighlight: "transform",
      titleEnd: "your business",
      subtitle: "Solutions that generate measurable results from the first month",
      items: [
        { title: "Increase your recovery", description: "Boost portfolio recovery rates between 20% and 45% with intelligent automation.", metric: "+45%", metricLabel: "Recovery" },
        { title: "Improve your cash flow", description: "Significant improvement in cash flow from the first month of implementation.", metric: "Month 1", metricLabel: "Results" },
        { title: "Reduce costs", description: "Reduce collection operating costs by up to 80% by automating manual processes.", metric: "-80%", metricLabel: "Costs" },
        { title: "Scalability", description: "Scale your operations without proportionally increasing your operational structure.", metric: "24/7", metricLabel: "Available" }
      ]
    },
    features: {
      title: "Technology that",
      titleHighlight: "drives",
      titleEnd: "results",
      subtitle: "Features designed to maximize your efficiency and recovery",
      badge: "Feature",
      items: [
        {
          title: "Full automation",
          description: "Automate your entire out-of-court and judicial collection process with cutting-edge technology.",
          features: ["Automated out-of-court collections", "Judicial collection management", "Automatic debtor follow-up", "Automated omnichannel communication"]
        },
        {
          title: "Artificial intelligence",
          description: "Optimize your collection strategies with AI that learns from your data and continuously improves.",
          features: ["AI optimization", "Automated invoice reading", "Payment behavior prediction", "Smart recommendations"]
        },
        {
          title: "Total visibility",
          description: "Real-time reports and 24/7 access from anywhere with our cloud platform.",
          features: ["Real-time reports", "24/7 cloud platform", "Customizable dashboard", "Integration with existing systems"]
        }
      ]
    },
    process: {
      title: "Simple",
      titleHighlight: "implementation",
      titleEnd: "process",
      subtitle: "We support you every step of the way to ensure your success",
      steps: [
        { step: "01", title: "Project validation", description: "We analyze your specific needs and design the ideal value proposition for your business." },
        { step: "02", title: "Development and customization", description: "We configure the platform according to your requirements and integrate it with your existing systems." },
        { step: "03", title: "Training", description: "We train your team to make the most of all the platform's features." },
        { step: "04", title: "Continuous support", description: "6 months of post-sales warranty with specialized and continuous assistance for your success." }
      ]
    },
    clients: {
      title: "Companies that trust",
      titleHighlight: "us",
      subtitle: "Success stories across different sectors and industries",
      footer: "More than 100 companies have transformed their collections management with us"
    },
    pricing: {
      title: "Plans designed for your",
      titleHighlight: "growth",
      subtitle: "No long-term contracts or monthly fees. You buy recharge packs based on your operation's volume.",
      popular: "Most popular",
      annual: "prepaid",
      request: "Request",
      successTitle: "Success fees",
      successHighlight: "(only when you recover)",
      successFooter: "Tiered fees based on the delinquency stage. You only pay when you effectively recover.",
      stages: [
        { stage: "Pre-judicial", days: "91-180 days", fee: "5%", description: "Mid delinquency" },
        { stage: "Judicial", days: "181-360 days", fee: "10%", description: "Advanced delinquency" },
        { stage: "Charged-off", days: "+360 days", fee: "15%", description: "Charged-off portfolio" }
      ]
    },
    testimonials: {
      title: "What our",
      titleHighlight: "clients",
      titleEnd: "say",
      subtitle: "SMBs that transformed their collections management and improved their liquidity"
    },
    faq: {
      title: "Frequently asked",
      titleHighlight: "questions",
      subtitle: "Answers to the most common questions about CollectPay",
      notFound: "Didn't find the answer you were looking for?",
      contactUs: "Contact us directly →"
    },
    contact: {
      title: "Ready to",
      titleHighlight: "transform",
      titleEnd: "your collections?",
      subtitle: "Request your personalized demo and discover how we can help you reactivate your liquidity",
      formName: "Full name",
      formEmail: "Email",
      formPhone: "Phone",
      formCompany: "Company",
      formPlan: "Plan of interest",
      formPlanPlaceholder: "Select a plan",
      formMessage: "Message",
      formMessagePlaceholder: "Tell us about your collection needs...",
      submit: "Request demo",
      submitting: "Sending...",
      success: "Request sent!",
      successDesc: "We will contact you within the next 24 hours.",
      error: "Error sending",
      errorDesc: "Please try again or call us directly.",
      legal: "By submitting this form, you accept our",
      and: "and",
      info: "Contact information",
      phone: "Phone",
      email: "Email",
      office: "Office",
      whyTitle: "Why request a demo?",
      why1: "See the platform in action with your data",
      why2: "Personalized advice with no commitment",
      why3: "Custom quote based on your volume",
      why4: "Response in less than 24 hours",
      captchaLabel: "Security verification",
      captchaError: "Incorrect answer. Please try again."
    },
    footer: {
      tagline: "Leading fintech platform for collections automation for SMBs. We improve your cash flow with technology and artificial intelligence.",
      product: "Product",
      productItems: ["Benefits", "Features", "Plans & Pricing", "Request Demo"],
      company: "Company",
      companyItems: ["About Us", "Success Stories", "Careers"],
      support: "Support",
      supportItems: ["FAQ", "Help Center", "Contact", "System Status"],
      legal: "Legal",
      legalItems: ["Terms and Conditions", "Privacy Policy", "Data Treatment", "Security"],
      copyright: "© 2026 CollectPay. All rights reserved.",
      madeWith: "Made with ♥ for SMBs"
    },
    whatsapp: {
      message: "Hello! I'm interested in learning more about CollectPay for my company."
    },
    careers: {
      title: "Work with us",
      subtitle: "Join the team that is transforming collections in Colombia",
      formName: "Full name",
      formEmail: "Email",
      formPosition: "Position of interest",
      formPositionPlaceholder: "E.g: Developer, Analyst, Sales",
      formMessage: "Cover letter (optional)",
      formMessagePlaceholder: "Tell us briefly why you want to work with us...",
      formCV: "Attach your CV (PDF or Word, max 5MB)",
      formCVHint: "Drag your file here or click to select",
      submit: "Submit application",
      submitting: "Sending...",
      success: "Application sent!",
      successDesc: "Thanks for your interest. We will review your CV and contact you soon.",
      error: "Error sending",
      errorDesc: "Please try again or send your CV to hola@collectpay.co",
      close: "Close"
    }
  }
};
